var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M411.151,201.697h-23.273h-46.545h-85.332h-85.333h-46.545h-23.274 c-12.853,0-23.273,10.42-23.273,23.273v263.758c0,12.853,10.42,23.273,23.273,23.273h155.153h155.15 c12.853,0,23.273-10.42,23.273-23.273V224.97C434.424,212.117,424.004,201.697,411.151,201.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C3C7"
    },
    d: "M170.668,131.877c0-47.051,38.281-85.332,85.332-85.332c47.053,0,85.333,38.281,85.333,85.332v69.82 h46.545v-69.82C387.879,59.161,328.718,0,256,0c-72.716,0-131.877,59.161-131.877,131.877v69.82h46.545V131.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M100.848,512h155.153V201.697h-85.333h-46.545h-23.274c-12.853,0-23.273,10.42-23.273,23.273v263.758 C77.576,501.58,87.996,512,100.848,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9A8AE"
    },
    d: "M124.123,131.879v69.818h46.545v-69.818c0-47.053,38.281-85.333,85.332-85.333V0 C183.284,0,124.123,59.161,124.123,131.879z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSvg);
export default __webpack_public_path__ + "static/media/lock-svg.8080cb6ddbd53233416ff3e40a0fd823.svg";
export { ForwardRef as ReactComponent };